import { mapGetters, mapActions } from 'vuex';

export default {
  computed: {
    ...mapGetters('entities', {
      fileEntities: 'files',
    }),
    ...mapGetters('dashboard/job', [
      'currentJobFilesMeta',
      'currentRawJobFiles',
    ]),
    files () {
      return (this.fileIds || this.currentRawJobFiles).map(
        fileId => this.fileEntities[fileId] && this.fileEntities[fileId]
      ).filter(Boolean);
    },
  },
  methods: {
    ...mapActions('dashboard/job', [
      'fetchFiles',
      'createFiles',
      'deleteFiles',
      'resetCurrentFilesError',
    ]),
  },
};
